export default {
	title: "Meeting Summary",
	description: "I’ve prepared a summary of your meeting notes below. At the top is an executive summary (TL;DR), followed by an itemized summary with recommended action items. You can click the ‘+’ next to any recommended action item to add it to your list.",
	viewTranscriptButton: "View full transcript",
	isThisHelpfulLabel: "Is this helpful?",
	expandDetailsLabel: "Expand details",
	collapseLabel: "Collapse details",
};
